import Image from "next/image";
import { Image as ChakraImage, useColorModeValue } from "@chakra-ui/react";
import { ClientType } from "@/lib/chakra/theme";
import { useAppSelector } from "@/lib/hooks";
import { CustomToolTip } from "../utils/common";
import JonesMd from "./images/jonesMd.png";
import JonesSm from "./images/jonesSm.png";
import VairitasLogoMd from "./images/vairitasMd.svg";
import VairitasLogoSm from "./images/vairitasSm.png";

type LogoSize = "md" | "sm";

type LogoEntry = {
  md: { src: string; width: number; height: number };
  sm: { src: string };
  defaultMdWidth: number;
};

const LOGO_CONFIG: Record<ClientType, LogoEntry> = {
  VAIRITAS: {
    md: {
      src: VairitasLogoMd.src,
      width: VairitasLogoMd.width,
      height: VairitasLogoMd.height,
    },
    sm: { src: VairitasLogoSm.src },
    defaultMdWidth: 200,
  },
  JONES: {
    md: {
      src: JonesMd.src,
      width: JonesMd.width,
      height: JonesMd.height,
    },
    sm: { src: JonesSm.src },
    defaultMdWidth: 200,
  },
};

type GetLogoProps = {
  width?: number;
  height?: number;
  size?: LogoSize;
  tooltip?: string;
  onLogoClick?: () => void;
};

export const GetLogo = ({
  width = undefined,
  height = undefined,
  size = "md",
  tooltip = "",
  onLogoClick,
}: GetLogoProps) => {
  const { clientType } = useAppSelector((state) => state.app);

  if (!clientType) return null;
  const config = LOGO_CONFIG[clientType];

  if (size === "sm") {
    return (
      <CustomToolTip placement={"bottom-start"} label={tooltip}>
        <span>
          <SmLogoWrapper src={config.sm.src} onLogoClick={onLogoClick} />
        </span>
      </CustomToolTip>
    );
  }

  if (width === undefined) width = config.defaultMdWidth;

  return (
    <Image
      onClick={() => {
        onLogoClick && onLogoClick();
      }}
      src={config.md.src}
      width={width || config.md.width}
      height={height || config.md.height}
      alt={clientType as string}
    />
  );
};

type SmLogoWrapperProps = {
  src: string;
  height?: string;
  onLogoClick?: () => void;
};

const SmLogoWrapper = ({
  src,
  height = "60px",
  onLogoClick,
}: SmLogoWrapperProps) => {
  const backgroundColor = useColorModeValue("#f0f0f0", "gray.800");

  const { clientType } = useAppSelector((state) => state.app);
  return (
    <ChakraImage
      onClick={() => {
        onLogoClick && onLogoClick();
      }}
      src={src}
      width={"auto"}
      height={height}
      minH={height}
      minW={"auto"}
      p={2}
      alt={clientType}
      borderRadius={8}
      transition={"0.3s"}
      _hover={{
        transform: "scale(1.05)",
        cursor: "pointer",
        backgroundColor,
      }}
    />
  );
};
